import { createContext, useContext } from 'react';
import type { Team, User } from './team.types';

export const userContext = createContext<User>(undefined as any);

export const teamIdContext = createContext<{
  teamId: string | undefined | null;
  setTeamId: (value: string | null) => void;
  isTeamSwitching: boolean;
  setIsTeamSwitching: (value: boolean) => void;
}>({
  teamId: undefined,
  setTeamId: () => undefined,
  isTeamSwitching: false,
  setIsTeamSwitching: () => undefined,
});

export const useTeamIdContext = () => useContext(teamIdContext);

export type TeamContextValue = {
  teamId: string;
  setTeamId: (value: string | null) => void;
  team: Team;
  role: 'admin' | 'owner' | 'user';
  isTeamAdmin: boolean;
  isPartnerAdmin: boolean;
  isVrpAdmin: boolean;
  isSuperAdmin: boolean;
  isFetchingTeam: boolean;
  queryError?: Error | null;
  refetchTeam: () => Promise<void>;
  queryKey: readonly unknown[];
};

export const teamContext = createContext<TeamContextValue>({
  isTeamAdmin: false,
  isPartnerAdmin: false,
  isVrpAdmin: false,
  isSuperAdmin: false,
  role: 'user',
  team: {} as any,
  teamId: '',
  isFetchingTeam: false,
  queryError: null,
  setTeamId: () => undefined,
  refetchTeam: async () => undefined,
  queryKey: [],
});
